import { Nullable } from '~/types/Nullable';
import { PilotId } from '~/types/PilotId';

export enum EsignatureEnvelopeStatusValue {
  Created = 'created',
  Sent = 'sent',
  Signed = 'signed',
  Declined = 'declined',
  Voided = 'voided',
  Error = 'error',
}

export type EsignatureEnvelopeStatus = {
  value: EsignatureEnvelopeStatusValue;
  label: string;
};

export type EsignatureEnvelope = {
  status: EsignatureEnvelopeStatus;
};

export enum EsignatureSignerStatusValue {
  SignatureRequestNotSent = 'signature-request-not-sent',
  Pending = 'signature-pending',
  Queued = 'queued',
  Signed = 'signed',
  Declined = 'declined',
  Error = 'error',
}

export type EsignatureSignerStatus = {
  label: string;
  value: EsignatureSignerStatusValue;
};

export type EsignatureRecipient = {
  isExternal: boolean;
  id: string;
  userId: Nullable<PilotId>;
  status: Nullable<EsignatureSignerStatus>;
  external: Nullable<{ name: string; email: string }>;
};

export type EsignatureCCRecipient = {
  id: string;
  name: string;
  email: string;
};

export type EsignatureActivity = {
  message: string;
  date: Date;
  userName: Nullable<string>;
};

export type EsignatureActivities = {
  activities: EsignatureActivity[];
};

export enum EsignatureTokenStatusValue {
  Uninitialized = 'UNINITIALIZED',
  Active = 'ACTIVE',
  Dead = 'DEAD',
}
